import Vue from 'vue';
import Router from 'vue-router';
import { getToken } from './utils/session';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', name: 'landing', component: () => import('./pages/Landing.vue') },
    { path: '/login', name: 'login', component: () => import('./pages/Login.vue') },
    { path: '/forgot-password', name: 'forgotPassword', component: () => import('./pages/ForgotPassword.vue') },
    { path: '/register', name: 'register', component: () => import('./pages/Register.vue') },
    { path: '/home', name: 'home', meta: { auth: true, tab: 'home' }, component: () => import('./pages/Home.vue') },
    { path: '/wallet', name: 'wallet', meta: { auth: true, tab: 'wallet' }, component: () => import('./pages/Wallet.vue') },
    { path: '/wallet/bind', name: 'bindWallet', meta: { auth: true, tab: 'wallet' }, component: () => import('./pages/BindWallet.vue') },
    { path: '/earnings', name: 'earnings', meta: { auth: true, tab: 'earnings' }, component: () => import('./pages/Earnings.vue') },
    { path: '/withdrawals', name: 'withdrawals', meta: { auth: true, tab: 'me' }, component: () => import('./pages/WithdrawalRequests.vue') },
    { path: '/withdrawals/:id', name: 'withdrawalDetail', meta: { auth: true, tab: 'me' }, component: () => import('./pages/WithdrawalDetail.vue') },
    { path: '/referral/withdrawals', name: 'referralWithdrawals', meta: { auth: true, tab: 'me' }, component: () => import('./pages/ReferralWithdrawals.vue') },
    { path: '/referral', name: 'referral', meta: { auth: true, tab: 'me' }, component: () => import('./pages/Referral.vue') },
    { path: '/telegram', name: 'telegram', meta: { auth: true, tab: 'me' }, component: () => import('./pages/TelegramBinding.vue') },
    { path: '/activity/withdrawals', name: 'activityWithdrawals', meta: { auth: true, tab: 'me' }, component: () => import('./pages/ActivityWithdrawals.vue') },
    { path: '/me', name: 'me', meta: { auth: true, tab: 'me' }, component: () => import('./pages/Me.vue') }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !getToken()) {
    next({ name: 'login', query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
